import { render, staticRenderFns } from "./AffiliationsTaskView.vue?vue&type=template&id=78f13d54&scoped=true&"
import script from "./AffiliationsTaskView.vue?vue&type=script&lang=js&"
export * from "./AffiliationsTaskView.vue?vue&type=script&lang=js&"
import style0 from "./AffiliationsTaskView.vue?vue&type=style&index=0&id=78f13d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f13d54",
  null
  
)

export default component.exports